import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiUser, FiMoon, FiSun, FiBell } from "react-icons/fi";
import { requestNotificationPermission } from "../firebase";
import toast from "react-hot-toast";
import axios from "../config/axios";
import { MiscApi } from "./Apis";
import { useTheme } from "../Utils/ThemeContext";

const Navbar = () => {
  const user = useSelector((state) => state.user.user);
  const token = useSelector((state) => state.token);
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="sticky top-0 z-30 bg-surface-overlay/80 border-b border-s-border backdrop-blur-xl transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="group flex items-center gap-3 bg-transparent border-none cursor-pointer p-0 focus:outline-none no-underline"
        >
          <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-orange-500 to-rose-500 flex items-center justify-center shadow-lg shadow-orange-500/20 group-hover:shadow-orange-500/40 transition-all duration-300 group-hover:scale-105">
            <span className="text-white font-bold text-sm tracking-wider">
              PB
            </span>
          </div>
          <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-on-surface to-on-surface-secondary tracking-tight">
            Admin
          </span>
        </Link>

        <div className="flex items-center gap-3">
          <button
            onClick={toggleTheme}
            aria-label="Toggle Dark Mode"
            className="relative p-2.5 rounded-xl bg-surface-inset border border-s-border text-on-surface-secondary hover:text-accent hover:border-accent shadow-sm hover:shadow transition-all duration-300 focus:outline-none"
          >
            <div className="relative w-4 h-4 flex items-center justify-center">
              <FiSun
                className={`absolute inset-0 w-full h-full transition-all duration-500 ${theme === "dark" ? "rotate-0 opacity-100 scale-100" : "-rotate-90 opacity-0 scale-50"}`}
              />
              <FiMoon
                className={`absolute inset-0 w-full h-full transition-all duration-500 ${theme === "light" ? "rotate-0 opacity-100 scale-100" : "rotate-90 opacity-0 scale-50"}`}
              />
            </div>
          </button>

          <Link
            to={user ? "/dashboard" : "/login"}
            aria-label="Profile"
            className="group flex items-center gap-2.5 px-4 py-2 rounded-xl border border-s-border bg-surface-inset text-on-surface text-sm font-semibold hover:border-accent hover:bg-surface-raised shadow-sm hover:shadow-[0_0_20px_rgba(249,115,22,0.1)] transition-all duration-300 focus:outline-none no-underline"
          >
            <div className="bg-surface p-1.5 rounded-lg group-hover:bg-accent-soft transition-colors">
              <FiUser className="w-3.5 h-3.5 text-on-surface-secondary group-hover:text-accent transition-colors" />
            </div>
            {user ? "Dashboard" : "Login"}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
